let BUILD_NUMBER = 0

const incrementBuildNumber = () => {
    BUILD_NUMBER += 1
}
module.exports = { BUILD_NUMBER, incrementBuildNumber }
